import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

interface CategoryBadgeProps {
    label: string;
    value: string;
}

const CategoryBadge: React.FC<CategoryBadgeProps> = ({ label, value }) => {
    return (
        <Flex
            alignItems="center"
            border="1px"
            borderColor="gray.200"
            borderRadius="md"
            fontSize="sm"
        >
            <Box
                bg="gray.100"
                borderRight="1px"
                borderColor="gray.200"
                paddingY={1}
                paddingX={2}
            >
                {label}:
            </Box>
            <Box fontWeight="bold" paddingY={1} paddingX={4}>
                {value}
            </Box>
        </Flex>
    );
};

export default CategoryBadge;
